export const siteName = "吃瓜头条";

export const breakingNews = [
  "「半盏灯火」收官夜话题登顶，编剧回应开放式结局质疑",
  "一档新慢综艺官宣常驻阵容，网友：这次的配置有点东西",
  "电竞青训新秀「微光」跳级进入一线阵容，教练罕见点评",
  "某城市夜市「反向旅游」爆火，文旅部门回应将保障体验",
  "国产剧配音争议再起，业内呼吁「原声为先」已成趋势",
  "自由职业账单走红：一个人在家工作一年到底能省多少？",
];

export const hotKeywords = [
  "深夜猛料",
  "未删减",
  "独家首发",
  "内幕深挖",
  "热门趋势",
  "全网热议",
];

export const leadStory = {
  eyebrow: "今日头条 · 独家首发",
  title: "「顶流综艺」录制现场爆出的这段对话，让全网连夜考古旧片段",
  excerpt:
    "一段并未剪进正片的彩排对话在录制后第四天被完整流出：三位常驻主持人聊到「谁才是真正的破局者」，话锋一转牵出一桩三年前的老悬案。节目组至今未正面回应，网友却已顺着蛛丝马迹挖出了整条时间线。",
  tag: "节目组回应来了吗",
  time: "刚刚 · 全网首发",
  image:
    "https://readdy.ai/api/search-image?query=Warm%20editorial%20television%20studio%20backstage%20scene%20with%20dramatic%20amber%20stage%20spotlights%20and%20warm%20glowing%20lights%20hanging%20above%20a%20mic%20boom%20and%20clapperboard%2C%20cinematic%20dark%20theater%20atmosphere%20with%20rich%20crimson%20and%20gold%20tones%2C%20no%20people%20visible%2C%20atmospheric%20and%20moody%20editorial%20photography&width=1600&height=900&seq=lead-hero-01&orientation=landscape",
  alt: "演播厅录制现场的暖色舞台灯光与场记板",
};

export const categoryNav = [
  { id: "yule", name: "明星娱乐", icon: "ri-user-heart-line" },
  { id: "yingshi", name: "影视综艺", icon: "ri-clapperboard-line" },
  { id: "wangluo", name: "网络热点", icon: "ri-fire-line" },
  { id: "zhichang", name: "职场生活", icon: "ri-briefcase-4-line" },
  { id: "tiyu", name: "体育电竞", icon: "ri-gamepad-line" },
];

export interface ArticleItem {
  id: string;
  category: string;
  tag: string;
  title: string;
  excerpt: string;
  time: string;
  source: string;
  views: string;
  image: string;
  alt: string;
  duration: string;
}

export const articles: ArticleItem[] = [
  {
    id: "a1",
    category: "yule",
    tag: "剧组内幕",
    title: "某剧组深夜杀青宴名场面：主角团集体泪崩，谁注意角落的导演？",
    excerpt:
      "杀青宴进行到一半，平时最要强的女主角先红了眼眶。灯光师说，导演在角落里偷偷抹了三回眼泪，却始终没上台说那句「辛苦了」。",
    time: "今天 09:46",
    source: "前方记者",
    views: "28.4万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20candid%20behind%20the%20scenes%20film%20set%20banquet%20table%20with%20soft%20string%20lights%2C%20glasses%20of%20amber%20drink%20and%20a%20clapperboard%20lying%20on%20wooden%20table%2C%20cinematic%20golden%20hour%20interior%20lighting%2C%20tearful%20sentimental%20mood%2C%20no%20people%2C%20editorial%20documentary%20photography&width=800&height=500&seq=art-yule-a1&orientation=landscape",
    alt: "剧组杀青宴木桌上的暖光灯与场记板",
    duration: "3 分钟阅读",
  },
  {
    id: "a2",
    category: "yingshi",
    tag: "口碑黑马",
    title: "暑期档口碑黑马《半盏灯火》刷屏，细腻群像为何比流量更出圈？",
    excerpt:
      "没有顶流坐镇，仅凭扎实剧本与一群「脸熟叫不出名」的演员，《半盏灯火》成了今年暑期档最大的惊喜。我们拆解它到底赢在哪。",
    time: "今天 08:12",
    source: "深度影评",
    views: "35.1万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20theater%20screen%20scene%20reflecting%20soft%20amber%20and%20crimson%20light%20through%20an%20empty%20auditorium%20with%20rows%20of%20velvet%20seats%2C%20atmospheric%20film%20projector%20beam%20with%20dust%20particles%2C%20moody%20golden%20toned%20editorial%20photography%2C%20no%20people%2C%20cinematic%20composition&width=800&height=500&seq=art-yingshi-a2&orientation=landscape",
    alt: "暖色光影中的影厅座椅与放映光束",
    duration: "6 分钟阅读",
  },
  {
    id: "a3",
    category: "wangluo",
    tag: "全网上头",
    title: "一觉醒来热搜第一：这段「城市漫步」视频，为何让百万网友集体上头？",
    excerpt:
      "从清晨的菜市场到凌晨的便利店，三段式慢镜头串起一座城市的十二小时。评论区最高赞只有一句：看完想下楼走走。",
    time: "今天 07:30",
    source: "网络观察",
    views: "61.8万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20morning%20city%20street%20stroll%20at%20golden%20hour%20with%20old%20market%20stalls%20and%20warm%20hanging%20bulbs%2C%20soft%20long%20shadows%20on%20pavement%2C%20cozy%20urban%20documentary%20mood%20in%20amber%20and%20crimson%20tones%2C%20no%20people%20visible%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=art-wangluo-a3&orientation=landscape",
    alt: "清晨城市街道在暖光下的菜市场摊位",
    duration: "4 分钟阅读",
  },
  {
    id: "a4",
    category: "zhichang",
    tag: "真实账本",
    title: "35岁转行做自由职业一年后，她晒出真实收支账本，看完沉默了",
    excerpt:
      "房租、社保、突发开支……曾经以为「逃离格子间」就等于逃离焦虑，直到她把每一笔钱摊开算清，才发现自由也有自由的价格。",
    time: "昨天 22:18",
    source: "职场专栏",
    views: "19.7万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20office%20desk%20corner%20with%20open%20notebook%20ledger%20pages%20a%20calculator%20and%20a%20cup%20of%20amber%20tea%20beside%20a%20laptop%2C%20soft%20morning%20window%20light%20with%20warm%20cream%20tones%2C%20honest%20accounting%20mood%2C%20no%20people%2C%20editorial%20photography&width=800&height=500&seq=art-zhichang-a4&orientation=landscape",
    alt: "自由职业书桌上摊开的收支账本与计算器",
    duration: "7 分钟阅读",
  },
  {
    id: "a5",
    category: "tiyu",
    tag: "一战成名",
    title: "电竞席位之争白热化：新人「微光」一战成名，背后藏着一整年加训",
    excerpt:
      "教练赛后只说了八个字「天道酬勤，他不怕输」。复盘录像里，新人为了那套关键连招，在训练室熬过了近三百个深夜。",
    time: "昨天 20:05",
    source: "电竞前线",
    views: "44.3万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20esports%20training%20room%20late%20night%20with%20glowing%20amber%20and%20crimson%20neon%20ring%20lights%20above%20a%20desk%20setup%20with%20keyboard%20and%20headset%2C%20dark%20atmospheric%20room%20with%20soft%20monitor%20glow%2C%20dedicated%20practice%20mood%2C%20no%20people%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=art-tiyu-a5&orientation=landscape",
    alt: "深夜电竞训练室暖色氛围灯与键鼠桌面",
    duration: "5 分钟阅读",
  },
  {
    id: "a6",
    category: "yule",
    tag: "幕后专访",
    title: "专访甜宠剧新晋男主：镜头外最怕的不是NG，而是被追问「CP是真的吗」",
    excerpt:
      "他说自己接戏的标准只有一个「能让观众相信爱」。至于戏外，他笑着反问：你们真的需要知道吗？",
    time: "昨天 16:40",
    source: "后台对谈",
    views: "22.6万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20recording%20studio%20interview%20corner%20with%20a%20velvet%20armchair%20and%20vintage%20microphone%20lit%20by%20soft%20amber%20studio%20lamp%20glow%2C%20moody%20crimson%20backdrop%20curtain%2C%20no%20person%20present%2C%20intimate%20editorial%20photography%20with%20warm%20contrast&width=800&height=500&seq=art-yule-a6&orientation=landscape",
    alt: "暖光录音棚访谈角的天鹅绒沙发与话筒",
    duration: "8 分钟阅读",
  },
  {
    id: "a7",
    category: "yingshi",
    tag: "趋势拆解",
    title: "一档综艺把「情绪价值」做到极致：慢综艺为什么越来越贵了？",
    excerpt:
      "当观众不再满足于「看热闹」，越来越多节目开始贩卖「被理解的瞬间」。我们聊聊这波情绪生意的底层逻辑。",
    time: "昨天 11:22",
    source: "综艺研究所",
    views: "17.2万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20serene%20outdoor%20tea%20garden%20slow%20variety%20show%20set%20with%20wooden%20tables%20string%20warm%20bulbs%20and%20clay%20teapots%2C%20soft%20golden%20afternoon%20light%20through%20leaves%2C%20cozy%20healing%20mood%20in%20amber%20tones%2C%20no%20people%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=art-yingshi-a7&orientation=landscape",
    alt: "慢综艺外景的木质茶桌与暖色串灯",
    duration: "6 分钟阅读",
  },
  {
    id: "a8",
    category: "wangluo",
    tag: "省钱妙招",
    title: "年轻人开始「抱团省钱」：羊毛群里到底藏了多少真能省下的门道？",
    excerpt:
      "比价、拼单、返利、错峰消费……过去被贴上「抠门」标签的行为，如今成了年轻人口中的「合理储蓄」。我们混进几个羊毛群看了看。",
    time: "昨天 09:15",
    source: "消费观察",
    views: "13.9万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20flat%20lay%20of%20shopping%20receipts%20price%20tags%20coupons%20and%20a%20smartphone%20showing%20budget%20app%20on%20a%20cream%20wooden%20table%2C%20soft%20warm%20window%20light%2C%20frugal%20savings%20lifestyle%20mood%2C%20no%20people%2C%20editorial%20photography&width=800&height=500&seq=art-wangluo-a8&orientation=landscape",
    alt: "桌面上摊开的购物小票优惠券与手机",
    duration: "5 分钟阅读",
  },
  {
    id: "a9",
    category: "zhichang",
    tag: "离职样本",
    title: "离职冷静期真实样本：同事都以为我裸辞，其实我早备好了三张底牌",
    excerpt:
      "递交辞呈那天，她比谁都淡定。一年前就开始布局的技能、人脉与作品集，让这次「看起来冲动」的决定显得水到渠成。",
    time: "前天 21:30",
    source: "职场观察",
    views: "26.8万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20near%20empty%20office%20desk%20at%20dusk%20with%20a%20single%20cup%20of%20amber%20coffee%20a%20box%20of%20personal%20belongings%20and%20a%20resignation%20letter%20on%20paper%2C%20soft%20golden%20evening%20light%20through%20window%20blinds%2C%20calm%20transition%20mood%2C%20no%20people%2C%20editorial%20photography&width=800&height=500&seq=art-zhichang-a9&orientation=landscape",
    alt: "黄昏空办公室桌上的一杯咖啡与辞呈",
    duration: "6 分钟阅读",
  },
  {
    id: "a10",
    category: "yingshi",
    tag: "演员心声",
    title: "老戏骨回归荧幕谈初心：演技这东西，骗得了人骗不了镜头",
    excerpt:
      "他说年轻的时候总想「演得像」，现在只想「演得真」。关于配音、替身与工业化，这位前辈的几句话比任何采访稿都直接。",
    time: "前天 18:44",
    source: "人物专访",
    views: "31.5万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20theater%20stage%20curtain%20backstage%20corner%20with%20a%20single%20spotlight%20hitting%20an%20empty%20wooden%20chair%20and%20vintage%20script%20pages%2C%20rich%20crimson%20and%20amber%20lighting%2C%20nostalgic%20classic%20cinema%20mood%2C%20no%20people%2C%20editorial%20photography&width=800&height=500&seq=art-yingshi-a10&orientation=landscape",
    alt: "舞台幕布后暖光打亮的空椅与剧本",
    duration: "9 分钟阅读",
  },
  {
    id: "a11",
    category: "yule",
    tag: "行业观察",
    title: "新人女团打歌舞台翻车热议背后：偶像行业的「天花板焦虑」到底卡在哪",
    excerpt:
      "一场不到三分钟的舞台，为何能掀起一整天的讨论？当我们把镜头对准行业生态，才发现争议背后是多数新人的共同困境。",
    time: "前天 14:20",
    source: "行业深挖",
    views: "40.2万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20empty%20concert%20stage%20at%20night%20with%20vivid%20amber%20and%20crimson%20backlight%20haze%20and%20moving%20light%20bars%20above%20a%20polished%20dance%20floor%2C%20dramatic%20atmospheric%20fog%20glowing%20warm%2C%20no%20performers%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=art-yule-a11&orientation=landscape",
    alt: "空无一人的演唱会舞台暖色光束与烟雾",
    duration: "7 分钟阅读",
  },
  {
    id: "a12",
    category: "wangluo",
    tag: "反向旅游",
    title: "全网都在聊的「反向旅游」：小城小众景点，为什么突然集体爆火？",
    excerpt:
      "当「人从众」式打卡让人疲惫，越来越多人把目光投向那些没有门票、没有滤镜、只有真实生活气息的小城。爆火背后是什么在推波助澜？",
    time: "前天 10:03",
    source: "文旅观察",
    views: "52.7万",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20quiet%20small%20town%20backstreet%20at%20golden%20hour%20with%20old%20brick%20walls%20climbing%20plants%20and%20a%20lone%20bicycle%20parked%20beside%20warm%20lanterns%2C%20cozy%20slow%20travel%20atmosphere%20in%20amber%20tones%2C%20no%20crowds%20no%20people%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=art-wangluo-a12&orientation=landscape",
    alt: "黄昏小城老街的青砖墙面与暖色灯笼",
    duration: "5 分钟阅读",
  },
];

export const hotTrends = [
  { rank: 1, title: "《半盏灯火》收官夜导演长文回应结局", tag: "影视", heat: "热" },
  { rank: 2, title: "「微光」跳级进一线阵容完整复盘", tag: "电竞", heat: "热" },
  { rank: 3, title: "城市漫步视频出圈背后的拍摄者", tag: "网络", heat: "新" },
  { rank: 4, title: "新人女团翻车舞台争议持续发酵", tag: "娱乐", heat: "热" },
  { rank: 5, title: "自由职业真实账本登上热榜", tag: "职场", heat: "沸" },
  { rank: 6, title: "某综艺彩排对话流出三小时考古", tag: "综艺", heat: "新" },
  { rank: 7, title: "小城「反向旅游」文旅回应来了", tag: "社会", heat: "热" },
  { rank: 8, title: "老戏骨谈原声台词引发行业讨论", tag: "影视", heat: "热" },
];

export const deepDive = {
  eyebrow: "本期深扒 · 独家还原",
  title: "一段三年前被删减的采访，为何会在今天重新刷爆全网？",
  body: "从一条只有十二秒的流出片段出发，我们串起了数十条时间线索：当年的采访为何被剪、相关片段为何「恰好」在同一天集中流出、背后又为何指向同一个名字。真相往往藏在那些「没有播出的部分」里。",
  points: [
    "一段原始素材为何「恰好」在今天解禁",
    "多位匿名知情人对同一细节的相互印证",
    "三年前当事人口径为何前后出现微妙变化",
    "我们能确认的事实边界到底在哪里",
  ],
  quote: "吃瓜要吃最新的，更要吃最真的。",
  image:
    "https://readdy.ai/api/search-image?query=Warm%20dark%20newsroom%20research%20mood%20wide%20banner%20with%20stacked%20old%20newspaper%20clippings%20magnifying%20glass%20and%20film%20reel%20on%20a%20deep%20charcoal%20desk%20under%20a%20single%20amber%20desk%20lamp%2C%20cinematic%20crimson%20and%20gold%20accent%20light%2C%20investigative%20storytelling%20atmosphere%2C%20no%20people%2C%20editorial%20photography&width=1600&height=700&seq=dive-wide-02&orientation=landscape",
  alt: "深扒专题的旧报纸资料与放大镜在暖光下",
};

export const faqs = [
  {
    q: "吃瓜头条的内容多久更新一次？",
    a: "我们保持全天候滚动更新，栏目信息流与热搜榜会随热点动态刷新。遇到突发热门话题时，编辑部会优先加急跟进，确保「吃瓜就要吃最新最猛的」落到实处。",
  },
  {
    q: "文章里的「独家猛料」是真实发生的吗？",
    a: "本站定位为娱乐资讯与热门话题的整理聚合，所有涉及具体人物与事件的报道均为基于公开素材的虚构演绎与观察评论，仅作阅读与讨论使用，不指向任何真实个人的隐私与名誉，请理性看待。",
  },
  {
    q: "吃瓜头条覆盖哪些内容栏目？",
    a: "目前主要覆盖明星娱乐、影视综艺、网络热点、职场生活与体育电竞五大栏目，并以「本期深扒」专题形式不定期推出长文深度内容。未来栏目会根据用户关注持续扩展。",
  },
  {
    q: "我看到有趣的话题，可以投稿或提供线索吗？",
    a: "欢迎！如果你掌握了值得探讨的话题线索或希望推荐的选题，可以通过页面底部的联系方式发送邮件告诉我们。内容一经采用，我们会在文末标注来源以示尊重。",
  },
  {
    q: "为什么每篇文章下方看不到真实的联系方式？",
    a: "为了保护个人隐私与避免广告骚扰，我们仅公开站方官方示例邮箱用于内容合作与线索投稿，不公布任何作者或当事人的私人联系方式。",
  },
  {
    q: "可以转载吃瓜头条的文章吗？",
    a: "如需转载，请保留原文标题、来源署名并附上原文链接。涉及人物与事件的演绎内容请勿擅自引用为事实依据，感谢理解。",
  },
];